import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class Tag extends Vue { 
	@Prop () type!: string
    @Prop () label!: string
}